import { useRouter } from 'vue-router'
import { useNotificationsStore } from '@/modules/notifications/stores/notifications.store'

const EXTERNAL_URL_PATTERN = /^https?:\/\//

export function useNotificationNavigation() {
  const router = useRouter()
  const notificationsStore = useNotificationsStore()

  function navigateToTarget(notification) {
    if (notification.shortcut) {
      if (EXTERNAL_URL_PATTERN.test(notification.shortcut)) {
        window.open(notification.shortcut, '_blank', 'noopener')
        return
      }

      router.push(notification.shortcut)
      return
    }

    router.push({ name: 'Notification Details', params: { id: notification._id } })
  }

  async function openNotification(notification) {
    if (!notification.read) {
      try {
        await notificationsStore.markAsRead(notification._id)
      }
      catch {
        // Navigation should not be blocked when marking as read fails
      }
    }

    navigateToTarget(notification)
  }

  return { navigateToTarget, openNotification }
}
